module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA6BAMAAAC0SOHgAAAAD1BMVEUAAAD/+wD/+wD/+wD/+wCqS7SMAAAABHRSTlMAVtTWUUZDYgAAAEZJREFUSMdjYFRxIQk4CTCIuJAIHBlUSNXixOBCMiBDCxkOI8f7jCak6XAWYBgFo2AU0BKMFn2jRd8oGAUjEYwWfYOy6AMAhdM5b4Cb5Y0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/main_click_1.png
// module id = uvlH
// module chunks = 1